import { registerPlugin } from '@capacitor/core';

import type { CapacitorValorPlayerPlugin } from './definitions';

const CapacitorValorPlayer = registerPlugin<CapacitorValorPlayerPlugin>('CapacitorValorPlayer', {
  web: () => import('./web').then(m => new m.CapacitorValorPlayerWeb()),
});

export * from './definitions';
export { CapacitorValorPlayer };
